import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ILink } from 'src/app/shared/interface/link';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IPictureData } from 'src/app/shared/components/picture/picture.component';

export interface ISingleSpotData {
  items: ISingleSpotItem[];
}

export interface ISingleSpotMedia {
  image: IPictureData;
}

export interface ISingleSpotItem {
  title: IUProperty<string>;
  description: IUProperty<string>;
  link: IUProperty<ILink>;
  media: IUProperty<ISingleSpotMedia>;
}

@Component({
  selector: 'app-single',
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SingleComponent {
  @Input() data: ISingleSpotData;
}
